<template>
    <div>
        <div class="banner-box" v-show="showSwip">
            <div class="title" v-show="item">
                <img @click="back" class="back" src="@/assets/report/year2023/back.png">
                <!--                <img @click="share" class="share-icon" src="@/assets/report/year2023/share.png">-->
                <!--                <img @click="toHistory" class="history-icon" src="@/assets/report/year2023/history.png">-->
            </div>
            <div class="title-none" v-show="!item">
                <img @click="back" class="back" src="@/assets/report/year2023/back.png">
                <img @click="toHistory" class="history-icon" src="@/assets/report/year2023/history.png">
            </div>
        </div>
        <van-swipe v-show="showSwip" class="bg-box" :style="{'height': height + 'px'}" :loop="false"
                   :show-indicators="false" vertical @change="changePage" ref="mySwipe">
            <van-swipe-item>
                <div class="page page1" :class="year == 2023 ? 'page12023' : 'page12024'">
                    <div class="p1-box" :class="{ 'rise-up': currentPage == p0 }">
                        <div class="register-box">
                            <span class="num-year">{{ page1.loginYear }}</span>年<span
                            class="num">{{ page1.loginMonth }}</span>月<span class="num">{{ page1.loginDay }}</span>日
                        </div>
                        <div>
                            <div class="p1 p">我们遇见彼此</div>
                            <div class="p2 p">从那时起</div>
                            <div class="p3 p">我们已经共同度过了<span class="num">{{ page1.continue }}</span>天</div>
                        </div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item v-show="item.sportNum > 0">
                <div class="page" :class="year == 2023 ? 'page22023' : 'page22024'">
                    <div class="p2-box" :class="{ 'rise-up': currentPage == p1 }">
                        <div class="p">这一年</div>
                        <div class="p p3">你运动了<span class="num">{{ item.sportNum }}</span>次</div>
                        <div class="p p3">总时长达到了<span class="num">{{ item.sportDuration }}</span>小时</div>
                        <div class="p p3">燃烧了<span class="num">{{ item.sportCal }}</span>千卡</div>
                        <div class="p">坚持是热爱生活的最好证明</div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item v-show="item.sportNum > 0">
                <div class="page"  :class="year == 2023 ? 'page32023' : 'page32024'">
                    <div :class="{ 'rise-up': currentPage == p2 }">
                        <div class="p4-box">
                            <div class="p">令人瞩目的是</div>
                            <div class="p3 p"><span class="num num-year">{{ sportMostMonth.month }}</span>月是你运动最多的月份
                            </div>
                            <div class="p">根据统计</div>
                            <div class="p3 p">该月运动达到<span class="num">{{ sportMostMonth.num }}</span>次</div>
                            <div class="p3 p">总时长达到<span class="num">{{ sportMostMonth.duration }}</span>小时</div>
                            <div class="p3 p">燃烧的热量更达到<span class="num">{{ sportMostMonth.cal }}</span>千卡
                            </div>
                        </div>
                        <div class="p4-box-2">
                            <div class="p"><span class="num num-year">{{ sportMaxDuration.month }}</span>月<span
                                class="num">{{ sportMaxDuration.day }}</span>日那天
                            </div>
                            <div class="p3 p">你运动了<span class="num">{{ sportMaxDuration.duration }}</span>分钟</div>
                            <div class="p3 p">燃烧了<span class="num">{{ sportMaxDuration.cal }}</span>千卡</div>
                            <div class="p">挥洒汗水的时光很畅快吧~</div>
                        </div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item v-show="item.sportNum > 0">
                <div class="page"  :class="year == 2023 ? 'page42023' : 'page42024'">
                    <div :class="{ 'rise-up': currentPage == p3 }">
                        <div class="p5-box">
                            <div class="p p3"><span class="num num-year">{{ sportEarliest.month }}</span>月<span
                                class="num">{{ sportEarliest.day }}</span>日<span
                                class="num">{{ sportEarliest.time }}</span></div>
                            <div class="p">这一天你早早地开启了运动</div>
                            <div class="p p3">完成了1次<span class="num">{{ sportEarliest.duration }}</span>分钟的<span
                                class="blod">{{ sportEarliest.sportType }}</span>
                            </div>
                        </div>
                        <div class="p5-box-2">
                            <div class="p p3"><span class="num num-year">{{ sportLatest.month }}</span>月<span
                                class="num">{{ sportLatest.day }}</span>日<span
                                class="num">{{ sportLatest.time }}</span></div>
                            <div class="p">是你运动最晚的一天</div>
                            <div class="p p3">完成了1次<span class="num">{{ sportLatest.duration }}</span>分钟的<span
                                class="blod">{{ sportLatest.sportType }}</span>
                            </div>
                        </div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item v-show="item.stepTotal > 0">
                <div class="page"  :class="year == 2023 ? 'page52023' : 'page52024'">
                    <div :class="{ 'rise-up': currentPage == p4 }">
                        <div class="p6-box">
                            <div class="p">在这一年里</div>
                            <div class="p3 p">你一共走了<span class="num">{{ format(item.stepTotal) }}</span>步</div>
                            <div class="p p3">达标的天数有<span class="num">{{ item.stepDayCompliance }}</span>天</div>
                            <div class="p">前往健康的道路从未停止</div>
                        </div>
                        <div class="p6-box-2">
                            <div class="p step-max-date">{{ stepMaxDay.month }}月{{ stepMaxDay.day }}日
                            </div>
                            <div class="p">这一天你创下了<span class="blod">单日步数最高纪录</span></div>
                            <div class="p p3"><span class="num num-year step-max">{{ stepMaxDay.value }}</span>步</div>
                            <div class="p">还记得那天见过什么风景吗？</div>
                        </div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item v-show="item.sleepNum > 0">
                <div class="page" :class="year == 2023 ? 'page62023' : 'page62024'">
                    <div :class="{ 'rise-up': currentPage == p5 }">
                        <div class="p7-box">
                            <div class="p">{{ year }}年</div>
                            <div class="p3 p">北斗陪伴你<span class="num">{{ item.sleepNum }}</span>个夜晚</div>
                        </div>
                        <div class="p7-box-2">
                            <div class="p"><span class="num num-year">{{ sleepDuration.avgHour }}</span>时<span
                                class="num">{{ sleepDuration.avgMinute }}</span>分
                            </div>
                            <div class="p3 p">平均睡眠时长</div>
                        </div>
                        <div class="p7-box-3">
                            <div class="p"><span class="num num-year">{{ item.sleepScoreAvg }}</span>分</div>
                            <div class="p3 p">平均睡眠分数</div>
                        </div>
                        <div class="p7-box-4">
                            <div class="p"><span class="num num-year">{{ sleepDurationMax.month }}</span>月<span
                                class="num">{{ sleepDurationMax.day }}</span>日那天
                            </div>
                            <div class="p3 p">你睡了<span class="num">{{ sleepDurationMax.duration }}</span>小时</div>
                            <div class="p">一定缓解了前一天的疲惫吧！</div>
                        </div>
                        <div class="p7-box-5">
                            睡个好觉，让疲惫的心灵得以歇息
                        </div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item v-show="item.challengeNum > 0">
                <div class="page" :class="year == 2023 ? 'page72023' : 'page72024'">
                    <div :class="{ 'rise-up': currentPage == p6 }">
                        <div class="p8-box">
                            <div class="p">挑战面前</div>
                            <div class="p">强者呼啸而上</div>
                        </div>
                        <div class="p8-box-2">
                            <div class="p">这一年</div>
                            <div class="p3 p">你参与了<span class="num">{{ item.challengeNum }}</span>次挑战赛</div>
                            <div class="p3 p">为自己赢得了<span class="num">{{ item.challengeMedalNum }}</span>枚勋章
                            </div>
                            <div v-if="item.challengeRank1 > 0">
                                <div class="p">其中</div>
                                <div class="p3 p">获得第1名的次数有<span class="num">{{ item.challengeRank1 }}</span>次
                                </div>
                            </div>
                        </div>
                    </div>
                    <img class="to-next" v-if="year == 2023" @click="toNext" src="@/assets/report/year2023/toNext.png">
                    <img class="to-next" v-if="year == 2024" @click="toNext" src="@/assets/report/year2024/toNext.png">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="page" :class="year == 2023 ? 'page82023' : 'page82024'">
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="page page9" v-show="!showSwip" :style="{'height': shareHeight + 'px'}">
            <div  :class="year == 2023 ? 'page9-12023' : 'page9-12024'"  v-show="!shareTag">
                <div class="title" v-if="item">
                    <img @click="back" class="back" src="@/assets/report/year2023/back.png">
                    <img @click="share" class="share-icon" src="@/assets/report/year2023/share.png">
                    <!--                <img @click="toHistory" class="history-icon" src="@/assets/report/year2023/history.png">-->
                </div>
                <div class="title-none" v-if="!item">
                    <img @click="back" class="back" src="@/assets/report/year2023/back.png">
                    <!--                    <img @click="toHistory" class="history-icon" src="@/assets/report/year2023/history.png">-->
                </div>
            </div>
            <div :class="year == 2023 ? 'page9-22023' : 'page9-22024'">
                <div class="head-box">
                    <img :class="year == 2023 ? 'user-img2023' : 'user-img2024'" :src="item.userAvatar? item.userAvatar : defaultImg">
                    <div :class="year == 2023 ? 'user-name2023' : 'user-name2024'">{{ item.userName }}</div>
                    <div :class="year == 2023 ? 'use-days2023' : 'use-days2024'">使用天数：<span class="num">{{ item.activeDays }}</span>天</div>
                </div>
                <div class="all-steps" :class="year == 2023 ? 'all-steps' : 'all-steps2024'"><span class="num">{{ format(item.stepTotal) }}</span>步</div>
                <div class="all-cals" :class="year == 2023 ? 'all-cals' : 'all-cals2024'"><span class="num">{{ item.calTotal }}</span>千卡</div>
                <div class="all-sport" :class="year == 2023 ? 'all-sport' : 'all-sport2024'"><span class="num">{{ item.sportNum }}</span>次</div>
                <div class="all-time" :class="year == 2023 ? 'all-time' : 'all-time2024'"><span class="num">{{ item.sportDuration }}</span>小时</div>
                <div class="best-like" :class="year == 2023 ? 'best-like' : 'best-like2024'"><span
                    class="like-sport">{{ item.sportNum > 0 ? item.sportTypeMax : '--' }}</span>
                </div>
                <div class="avg-score" :class="year == 2023 ? 'avg-score' : 'avg-score2024'" v-if="item.sleepScoreAvg > 0"><span class="num">{{ item.sleepScoreAvg }}</span>分
                </div>
                <div class="avg-score" :class="year == 2023 ? 'avg-score' : 'avg-score2024'" v-if="!item.sleepScoreAvg"><span class="like-sport">--</span></div>
                <div class="avg-time" :class="year == 2023 ? 'avg-time' : 'avg-time2024'" v-if="sleepDuration.avgHour > 0"><span
                    class="num">{{ sleepDuration.avgHour ? sleepDuration.avgHour : '--' }}</span>小时<span
                    class="num next-num">{{ sleepDuration.avgMinute ? sleepDuration.avgMinute : '--' }}</span>分钟
                </div>
                <div class="avg-time" :class="year == 2023 ? 'avg-time' : 'avg-time2024'" v-if="!sleepDuration.avgHour"><span class="like-sport">--</span></div>
                <div class="all-num" :class="year == 2023 ? 'all-num' : 'all-num2024'"><span class="num">{{ item.challengeNum }}</span>次</div>
                <div class="all-medal" :class="year == 2023 ? 'all-medal' : 'all-medal2024'"><span class="num">{{ item.challengeMedalNum }}</span>枚</div>
            </div>
            <div :class="year == 2023 ? 'page9-32023' : 'page9-32024'" v-show="!shareTag">
                <div :class="year == 2023 ? 'btn-review2023' : 'btn-review2024'" @click="review"></div>
                <div :class="year == 2023 ? 'btn-share2023' : 'btn-share2024'" @click="share"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {Toast} from 'vant'
import {getQueryVariable} from '@/utils/comment'
import {getDaysBetweenDates} from '@/utils/dateUtils'
import {format, GetMinute} from '@/utils/math'
import 'animate.css'
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'year',
    data() {
        return {
            defaultImg: require('@/assets/share/home/noImg.png'),
            showSwip: true,
            item: {
                stepTotal: 0,
                calTotal: 0,
                sportNum: 0,
                sportDuration: 0
            },
            height: 800,
            isRadio: true,
            checkbox: 0,
            checked: true,
            page1: {
                loginYear: '',
                loginMonth: '',
                loginDay: '',
                continue: ''
            },
            sportMostMonth: {},
            sportMaxDuration: {},
            sportEarliest: {},
            sportLatest: {},
            stepMaxDay: {},
            sleepDuration: {},
            sleepDurationMax: {},
            swipPage: 1,
            currentPage: 0,
            haveSport: 0,
            haveStep: 0,
            haveSleep: 0,
            haveChallenge: 0,
            p0: 0,
            p1: 1,
            p2: 2,
            p3: 3,
            p4: 4,
            p5: 5,
            p6: 6,
            ratio: 1,
            shareHeight: 1123,
            shareTag: 0,
            year: 2023
        }
    },
    beforeCreate() {
        let count = 0;
        let imgs = [
            //用require的方式添加图片地址，直接添加图片地址的话，在build打包之后会查找不到图片，因为打包之后的图片名称会有一个加密的字符串
            require('@/assets/report/year2023/bg1.png'),
            require('@/assets/report/year2023/bg2.png'),
            require('@/assets/report/year2023/bg3.png'),
            require('@/assets/report/year2023/bg4.png'),
            require('@/assets/report/year2023/bg5.png'),
            require('@/assets/report/year2023/bg6.png'),
            require('@/assets/report/year2023/bg7.png'),
            require('@/assets/report/year2023/bg8.png'),
            require('@/assets/report/year2023/bg91.png'),
            require('@/assets/report/year2023/bg92.png'),
            require('@/assets/report/year2023/bg93.png')
        ]
        for (let img of imgs) {
            let image = new Image();
            image.onload = () => {
                count++;
            };
            image.src = img;
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.shareHeight = this.ratio * 1123;
        window.shareComplete = this.shareComplete;
        this.getHeight();
        if (this.$route.query.year) {
            this.year = this.$route.query.year;
        } else {
            this.year = new Date().getFullYear() - 1
        }
        this.getSportYear();
    },
    methods: {
        back() {
            this.$router.push({
                name: 'newSportList',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        share() {
            this.shareTag = 1;
            this.shareHeight = this.ratio * 879;
            console.log("click share")
            WebJSBridge.call("shareReport", null, function (res) {
                console.log("recieve callback")
                console.log(res)
            });
        },
        toHistory() {
            this.$router.push({
                name: 'monthHistory',
                query: {
                    userId: this.userId,
                    year: '',
                    theme: this.theme
                }
            })
        },
        getHeight() {
            this.height = window.innerHeight;
            console.log(this.height)
        },
        getSportYear() {
            this.$api.report.getSportYear({
                userId: getQueryVariable('userId') ? getQueryVariable('userId') : '',
                year: this.year
            }).then(res => {
                this.item = res.info
                this.dealInfo();
            })
        },
        dealInfo() {
            console.log(2)
            this.page1.loginYear = this.item.loginDate.substring(0, 4);
            this.page1.loginMonth = parseInt(this.item.loginDate.substring(5, 7));
            this.page1.loginDay = parseInt(this.item.loginDate.substring(8, 10));
            this.page1.continue = getDaysBetweenDates(this.item.loginDate, new Date);
            this.item.calTotal = format(Math.floor(this.item.calTotal / 1000));
            if (this.item.sportNum > 0) {
                this.swipPage = this.swipPage + 3;
                this.item.sportDuration = (this.item.sportDuration / 3600).toFixed(1);
                this.item.sportCal = Math.round(this.item.sportCal / 1000);
                this.sportMostMonth = JSON.parse(this.item.sportMostMonth);
                this.sportMostMonth.month = parseInt(this.sportMostMonth.startDate.substring(5, 7));
                this.sportMostMonth.duration = (this.sportMostMonth.duration / 3600).toFixed(1);
                this.sportMostMonth.cal = Math.round(this.sportMostMonth.cal / 1000);
                this.sportMaxDuration = JSON.parse(this.item.sportMaxDuration);
                this.sportMaxDuration.month = parseInt(this.sportMaxDuration.startSportTime.substring(5, 7));
                this.sportMaxDuration.day = parseInt(this.sportMaxDuration.startSportTime.substring(8, 10));
                this.sportMaxDuration.duration = Math.round(this.sportMaxDuration.actTime / 60);
                this.sportMaxDuration.cal = Math.round(this.sportMaxDuration.calories / 1000);
                this.sportEarliest = JSON.parse(this.item.sportEarliest);
                this.sportEarliest.month = parseInt(this.sportEarliest.startSportTime.substring(5, 7));
                this.sportEarliest.day = parseInt(this.sportEarliest.startSportTime.substring(8, 10));
                this.sportEarliest.time = this.sportEarliest.startSportTime.substring(11, 19);
                this.sportEarliest.duration = Math.round(this.sportEarliest.actTime / 60);
                this.sportLatest = JSON.parse(this.item.sportLatest);
                this.sportLatest.month = parseInt(this.sportLatest.startSportTime.substring(5, 7));
                this.sportLatest.day = parseInt(this.sportLatest.startSportTime.substring(8, 10));
                this.sportLatest.time = this.sportLatest.startSportTime.substring(11, 19);
                this.sportLatest.duration = Math.round(this.sportLatest.actTime / 60);
                this.haveSport = 1;
            }
            if (this.item.stepTotal > 0) {
                this.swipPage = this.swipPage + 1;
                this.stepMaxDay = JSON.parse(this.item.stepMaxDay);
                this.stepMaxDay.month = parseInt(this.stepMaxDay.date.substring(5, 7));
                this.stepMaxDay.day = parseInt(this.stepMaxDay.date.substring(8, 10));
                this.stepMaxDay.value = format(this.stepMaxDay.value)
                this.haveStep = 1;
            }
            if (this.item.sleepNum > 0) {
                this.swipPage = this.swipPage + 1;
                this.sleepDuration = JSON.parse(this.item.sleepDuration);
                this.sleepDuration.avgHour = Math.floor(this.sleepDuration.avg / 60);
                this.sleepDuration.avgMinute = Math.floor(this.sleepDuration.avg / 60);
                this.sleepDurationMax.month = parseInt(this.sleepDuration.max.date.substring(5, 7));
                this.sleepDurationMax.day = parseInt(this.sleepDuration.max.date.substring(8, 10));
                this.sleepDurationMax.duration = (this.sleepDuration.max.value / 60).toFixed(1);
                this.haveSleep = 1;
            }
            if (this.item.challengeNum > 0) {
                this.swipPage = this.swipPage + 1;
                this.haveChallenge = 1;
            }

            if (this.haveSport) {
                this.p1 = 1;
                this.p2 = 2;
                this.p3 = 3
                if (this.haveStep) {
                    this.p4 = 4
                    if (this.haveSleep) {
                        this.p5 = 5;
                    } else {
                        this.p6 = 5
                    }
                } else {
                    if (this.haveSleep) {
                        this.p5 = 4
                        if (this.haveChallenge) {
                            this.p6 = 5
                        }
                    } else {
                        if (this.haveChallenge) {
                            this.p6 = 4
                        }
                    }
                }
            } else {
                if (this.haveStep) {
                    this.p4 = 1
                    if (this.haveSleep) {
                        this.p5 = 2;
                        this.p6 = 3;
                    } else {
                        this.p6 = 2
                    }
                } else {
                    if (this.haveSleep) {
                        this.p5 = 1
                        this.p6 = 2
                    } else {
                        this.p6 = 1
                    }
                }
            }

        },
        changePage(index) {
            console.log("current:" + index, "swipPage:" + this.swipPage);
            this.currentPage = index;
            let _this = this;
            setTimeout(function () {
                if (index == _this.swipPage) {
                    _this.showSwip = false
                }
            }, 500)

        },
        review() {
            this.showSwip = true
            this.$refs.mySwipe.swipeTo(0);
        },
        format(n) {
            return format(n)
        },
        toNext() {
            console.log(111)
            this.$refs.mySwipe.next();
        },
        shareComplete() {
            this.shareTag = 0;
            this.shareHeight = this.ratio * 1123;
        }
    }
}
</script>

<style scoped>
.bg-box {
    height: 100%;
    width: 100%;
}

.van-swipe-item {
    color: #000000;
}

.page {
    position: relative;
    height: 100%;
    font-family: HM;
    color: #373737;
    background-color: #eaede1 !important;
}

.page12023 {
    background: url("~@/assets/report/year2023/bg2.png");
    background-size: 375px;
    position: relative;
}

.page12024 {
    background: url("~@/assets/report/year2024/bg2.png");
    background-size: 375px;
    position: relative;
}

.page22023 {
    background: url("~@/assets/report/year2023/bg3.png");
    background-size: 375px;
    position: relative;
}

.page22024 {
    background: url("~@/assets/report/year2024/bg3.png");
    background-size: 375px;
    position: relative;
}

.page32023 {
    background: url("~@/assets/report/year2023/bg4.png");
    background-size: 375px;
    position: relative;
}

.page32024 {
    background: url("~@/assets/report/year2024/bg4.png");
    background-size: 375px;
    position: relative;
}

.page42023 {
    background: url("~@/assets/report/year2023/bg5.png");
    background-size: 375px;
    position: relative;
}

.page42024 {
    background: url("~@/assets/report/year2024/bg5.png");
    background-size: 375px;
    position: relative;
}

.page52023 {
    background: url("~@/assets/report/year2023/bg6.png");
    background-size: 375px;
    position: relative;
}

.page52024 {
    background: url("~@/assets/report/year2024/bg6.png");
    background-size: 375px;
    position: relative;
}

.page62023 {
    background: url("~@/assets/report/year2023/bg7.png");
    background-size: 375px;
    position: relative;
}

.page62024 {
    background: url("~@/assets/report/year2024/bg7.png");
    background-size: 375px;
    position: relative;
}

.page72023 {
    background: url("~@/assets/report/year2023/bg8.png");
    background-size: 375px;
    position: relative;
}

.page72024 {
    background: url("~@/assets/report/year2024/bg8.png");
    background-size: 375px;
    position: relative;
}

.page82023 {
    background: url("~@/assets/report/year2023/bg9.png");
    background-size: 375px;
    height: 1123px;
    position: relative;
    color: #373737;
    font-size: 14px;
}

.page82024 {
    background: url("~@/assets/report/year2024/bg9.png");
    background-size: 375px;
    height: 1123px;
    position: relative;
    color: #373737;
    font-size: 14px;
}

.page9 {
    height: 1123px;
    color: #373737;
    font-size: 14px;
}

.page9-12023 {
    background: url("~@/assets/report/year2023/bg91.png");
    background-size: 375px;
    height: 78px;
    position: relative;
}

.page9-12024 {
    background: url("~@/assets/report/year2024/bg91.png");
    background-size: 375px;
    height: 78px;
    position: relative;
}

.title {
    background-size: 375px;
    width: 375px;
    height: 78px;
    position: relative;
}

.back {
    width: 22px;
    height: 22px;
    position: absolute;
    left: 15px;
    top: 55px;
}

.share-icon {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 55px;
    /*right: 47px;*/
    right: 15px;
}

.history-icon {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 55px;
    right: 15px;
}

.page9-22023 {
    background: url("~@/assets/report/year2023/bg92.png");
    background-size: 375px;
    height: 879px;
    position: relative;
    color: #373737;
    font-size: 14px;
}

.page9-22024 {
    background: url("~@/assets/report/year2024/bg92.png");
    background-size: 375px;
    height: 904px;
    position: relative;
    color: #373737;
    font-size: 14px;
}

.page9-32023 {
    background: url("~@/assets/report/year2023/bg93.png");
    background-size: 375px;
    height: 166px;
    position: relative;
    color: #373737;
    font-size: 14px;
}

.page9-32024 {
    background: url("~@/assets/report/year2024/bg93.png");
    background-size: 375px;
    height: 160px;
    position: relative;
    color: #373737;
    font-size: 14px;
}

.page9-22023 .num {
    font-size: 24px;
    margin: 0 5px 0 0;
}

.page9-22024 .num {
    font-size: 24px;
    margin: 0 5px 0 0;
}

.green {
    font-weight: bold;
    color: #2AAF67;
}

.radio-text {
    font-size: 14px;
    color: #707070;
    vertical-align: center;
    letter-spacing: 1px;
}

.open-btn {
    background: url("~@/assets/report/year2023/btnbg.png");
    background-size: 215px;
    width: 215px;
    height: 68px;
    position: absolute;
    bottom: 20px;
}

/deep/ .van-icon {
    border-radius: 3px;
}

.radio {
    display: inline-block;
}

.radio-box {
    position: absolute;
    bottom: 50px;
    margin: 0 auto;
    width: 100%;
}

.register-box {
    width: 100%;
    text-align: left;
    margin-left: 28px;
    padding-top: 103px;
    font-size: 20px;
}

@keyframes siz {
    from {
        transform: translateY(100px);
    }
    to {
        transform: translateY(0);
    }
}

.p4-box {
    padding-top: 93px;
}

.p {
    font-size: 20px;
    text-align: left;
    margin-left: 28px;
    margin-top: 20px;
}

.p3 {
    margin-top: 9px;
}

.num-year {
    font-size: 36px;
    font-weight: bold;
    font-family: D-D;
    margin: 0 5px 0 0 !important;
    color: #000000;
}

.num {
    font-size: 36px;
    font-weight: bold;
    font-family: D-D;
    margin: 0 5px;
    color: #000000;
}

.to-next {
    position: absolute;
    width: 26px;
    left: 175px;
    bottom: 20px;
}

.p2-box {
    position: absolute;
    bottom: 104px;
}

.p4-box-2 {
    position: absolute;
    top: 587px;
    margin-top: -12px;
    margin-left: 120px;
}

.p4-box-2 .num {
    font-size: 24px;
}

.p4-box-2 .p {
    font-size: 14px;
    margin-top: 12px;
    margin-left: 0;
}

.p4-box-2 .p3 {
    margin-top: 6px;
}

.p5-box {
    padding-top: 128px;
}

.p5-box-2 {
    margin-top: 225px;
}

.blod {
    font-size: 28px;
    font-weight: bold;
    margin: 0 5px;
    color: #000000;
}

.p6-box {
    padding-top: 196px;
}

.p6-box-2 {
    position: absolute;
    top: 578px;
    margin-top: -12px;
    font-size: 14px;
    margin-left: 120px;
}

.p6-box-2 .num {
    font-size: 24px;
}

.p6-box-2 .p {
    font-size: 14px !important;
    margin-top: 12px;
    margin-left: 0;
}

.p6-box-2 .p3 {
    margin-top: 6px;
}

.p6-box-2 .blod {
    font-size: 14px;
}

.step-max {
    text-decoration: underline;
}

.step-max-date {
    font-family: HM;
    font-size: 14px !important;
    font-weight: bold;
    color: #000000;
}

.p7-box {
    position: absolute;
    top: 102px;
    margin-top: -20px;
}

.p7-box-2 {
    position: absolute;
    font-size: 14px;
    top: 221px;
    margin-left: 53px;
    margin-top: -8px;
}

.p7-box-2 .p {
    font-size: 14px;
    margin-left: 0;
    margin-top: 8px;
}

.p7-box-2 .num {
    font-size: 24px;
}

.p7-box-3 {
    position: absolute;
    font-size: 14px;
    top: 336px;
    margin-left: 53px;
    margin-top: -8px;
}

.p7-box-3 .p {
    font-size: 14px !important;
    margin-left: 0;
    margin-top: 8px;
}

.p7-box-3 .num {
    font-size: 24px;
}

.p7-box-4 {
    position: absolute;
    font-size: 14px;
    top: 552px;
    margin-left: 53px;
    margin-top: -12px;
}

.p7-box-4 .p {
    font-size: 14px !important;
    margin-left: 0;
    margin-top: 12px;
}

.p7-box-4 .p3 {
    margin-top: 6px;
}

.p7-box-4 .num {
    font-size: 24px;
}

.p7-box-5 {
    position: absolute;
    left: 28px;
    font-size: 20px;
    top: 708px;
}

.p8-box {
    padding-top: 76px;
}

.p8-box-2 {
    padding-top: 300px;
}

.user-img2023 {
    width: 44px;
    height: 44px;
    background: #FFFFFF;
    opacity: 1;
    border: 2px solid rgba(255, 255, 255, 0.69);
    border-radius: 50%;
    position: absolute;
    top: 18px;
    left: 26px;
}

.user-img2024 {
    width: 44px;
    height: 44px;
    background: #FFFFFF;
    opacity: 1;
    border: 2px solid rgba(255, 255, 255, 0.69);
    border-radius: 50%;
    position: absolute;
    top: 90px;
    left: 53px;
}

.user-name2023 {
    font-weight: bold;
    font-size: 16px;
    position: absolute;
    top: 17px;
    left: 81px;
}

.user-name2024 {
    font-weight: bold;
    font-size: 16px;
    position: absolute;
    top: 89px;
    left: 106px;
}

.use-days2023 {
    position: absolute;
    top: 39px;
    left: 81px;
}

.use-days2024 {
    position: absolute;
    top: 111px;
    left: 106px;
}

.all-steps {
    position: absolute;
    top: 288px;
    left: 53px;
}

.all-steps2024 {
    position: absolute;
    top: 312px;
    left: 53px;
}

.all-cals {
    position: absolute;
    top: 288px;
    left: 211px;
}

.all-cals2024 {
    position: absolute;
    top: 312px;
    left: 211px;
}

.all-sport {
    position: absolute;
    top: 365px;
    left: 53px;
}

.all-sport2024 {
    position: absolute;
    top: 389px;
    left: 53px;
}

.all-time {
    position: absolute;
    top: 365px;
    left: 211px;
}

.all-time2024 {
    position: absolute;
    top: 389px;
    left: 211px;
}

.best-like {
    position: absolute;
    top: 442px;
    left: 53px;
}

.best-like2024 {
    position: absolute;
    top: 466px;
    left: 53px;
}

.avg-score {
    position: absolute;
    top: 580px;
    left: 53px;
}

.avg-score2024 {
    position: absolute;
    top: 604px;
    left: 53px;
}

.avg-time {
    position: absolute;
    top: 580px;
    left: 211px;
}

.avg-time2024 {
    position: absolute;
    top: 604px;
    left: 211px;
}

.all-num {
    position: absolute;
    top: 719px;
    left: 53px;
}

.all-num2024 {
    position: absolute;
    top: 743px;
    left: 53px;
}

.all-medal {
    position: absolute;
    top: 719px;
    left: 211px;
}

.all-medal2024 {
    position: absolute;
    top: 743px;
    left: 211px;
}

.like-sport {
    font-size: 19px;
    font-weight: bold;
}

.btn-review2023 {
    background: url("~@/assets/report/year2023/btnbg3.png");
    background-size: 130px;
    width: 130px;
    height: 51px;
    position: absolute;
    bottom: 24px;
    left: 21px;
}

.btn-review2024 {
    background: url("~@/assets/report/year2024/btnbg3.png");
    background-size: 130px;
    width: 130px;
    height: 46px;
    position: absolute;
    bottom: 24px;
    left: 21px;
}

.btn-share2023 {
    background: url("~@/assets/report/year2023/btnbg2.png");
    background-size: 192px;
    width: 192px;
    height: 51px;
    position: absolute;
    bottom: 24px;
    right: 21px;
}

.btn-share2024 {
    background: url("~@/assets/report/year2024/btnbg2.png");
    background-size: 192px;
    width: 192px;
    height: 46px;
    position: absolute;
    bottom: 24px;
    right: 21px;
}

.banner-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    color: #fff;
    z-index: 9999;
}

.next-num {
    margin: 0 5px !important;
}

@keyframes rise-up {
    0% {
        opacity: 0;
        -webkit-transform: translateY(100px);
        transform: translateY(100px);
    }
    100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.rise-up {
    animation: rise-up 1s forwards;
}

@keyframes nextA {
    0% {
        bottom: 20px;
    }
    50% {
        bottom: 25px;
    }
    100% {
        bottom: 20px; /* 中间状态透明度为1 */
    }
}

.to-next {
    animation: nextA 2s ease infinite; /* 设置动画属性 */
}
</style>



// WEBPACK FOOTER //
// src/views/report/year.vue